import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgoCommonAch, LazySvgoCommonArrowWhite, LazySvgoCommonArrow, LazySvgoCommonBgPattern, LazySvgoCommonCn, LazySvgoCommonDonwArrow, LazySvgoCommonEn, LazySvgoCommonFaster, LazySvgoCommonFooterLogoWhite, LazySvgoCommonIconArrow, LazySvgoCommonIconBankGrey, LazySvgoCommonIconCheck, LazySvgoCommonIconCode, LazySvgoCommonIconCryptowallet, LazySvgoCommonIconDelete, LazySvgoCommonIconDown, LazySvgoCommonIconGroup, LazySvgoCommonIconPig, LazySvgoCommonIconRing, LazySvgoCommonIconShowcases, LazySvgoCommonIconTradeWithUs, LazySvgoCommonIconUnsubscribe, LazySvgoCommonIconWallet, LazySvgoCommonIconX, LazySvgoCommonKey, LazySvgoCommonLogo, LazySvgoCommonMastercard, LazySvgoCommonNews, LazySvgoCommonSelector, LazySvgoCommonSepa, LazySvgoCommonSwift, LazySvgoCommonToastWarn, LazySvgoCommonVisa, LazySvgoDevelopersCloseIndex, LazySvgoDevelopersGradientArrow, LazySvgoDevelopersLogoGoldExtended, LazySvgoDevelopersOpenIndex, LazySvgoDevelopersStructureChart, LazySvgoHomeCryptoinfrastrIcon, LazySvgoHomeFlagEuropean, LazySvgoHomeFlagSouthAfrica, LazySvgoHomeFlagSouthKorea, LazySvgoHomeLegendPayLogo, LazySvgoHomeMoreArrow, LazySvgoHomeProIcon, LazySvgoHomeSafeIcon, LazySvgoHomeSettlementIcon, LazySvgoHomeSupportIcon, LazySvgoHomeTradingIcon, LazySvgoHomeWorldliquidityIcon, LazySvgoHomeZaIcon1, LazySvgoHomeZaIcon2, LazySvgoHomeZaIcon3, LazySvgoHomeZaIcon4, LazySvgoHomeZaIcon5, LazySvgoMenuFooterLogoWhite, LazySvgoMenuHeaderLogo, LazySvgoMenuLinkedIn, LazySvgoMenuLinkedinBlue, LazySvgoMenuMMenuBlack, LazySvgoMenuMMenuClose, LazySvgoMenuMMenuWhite, LazySvgoMenuMMenu, LazySvgoMenuTreasureBox, LazySvgoMenuTriangle, LazySvgoMenuTwitterBlue, LazySvgoMenuTwitter, LazySvgoMenuX, LazySvgoShadowbgChartlineGold, LazySvgoShadowbgEdge, LazySvgoShadowbgEdge2, LazySvgoShadowbgShapeInterrupt, LazySvgoTradingOtcLiquidityIcon, LazySvgoTradingOtcSettlementIcon, LazySvgoTradingOtcWorldclassIcon, LazyProseA, LazyProseBlockquote, LazyProseCode, LazyProseEm, LazyProseH1, LazyProseH2, LazyProseH3, LazyProseH4, LazyProseH5, LazyProseH6, LazyProseHr, LazyProseImg, LazyProseLi, LazyProseOl, LazyProseP, LazyProsePre, LazyProseScript, LazyProseStrong, LazyProseTable, LazyProseTbody, LazyProseTd, LazyProseTh, LazyProseThead, LazyProseTr, LazyProseUl } from '#components'
const lazyGlobalComponents = [
  ["SvgoCommonAch", LazySvgoCommonAch],
["SvgoCommonArrowWhite", LazySvgoCommonArrowWhite],
["SvgoCommonArrow", LazySvgoCommonArrow],
["SvgoCommonBgPattern", LazySvgoCommonBgPattern],
["SvgoCommonCn", LazySvgoCommonCn],
["SvgoCommonDonwArrow", LazySvgoCommonDonwArrow],
["SvgoCommonEn", LazySvgoCommonEn],
["SvgoCommonFaster", LazySvgoCommonFaster],
["SvgoCommonFooterLogoWhite", LazySvgoCommonFooterLogoWhite],
["SvgoCommonIconArrow", LazySvgoCommonIconArrow],
["SvgoCommonIconBankGrey", LazySvgoCommonIconBankGrey],
["SvgoCommonIconCheck", LazySvgoCommonIconCheck],
["SvgoCommonIconCode", LazySvgoCommonIconCode],
["SvgoCommonIconCryptowallet", LazySvgoCommonIconCryptowallet],
["SvgoCommonIconDelete", LazySvgoCommonIconDelete],
["SvgoCommonIconDown", LazySvgoCommonIconDown],
["SvgoCommonIconGroup", LazySvgoCommonIconGroup],
["SvgoCommonIconPig", LazySvgoCommonIconPig],
["SvgoCommonIconRing", LazySvgoCommonIconRing],
["SvgoCommonIconShowcases", LazySvgoCommonIconShowcases],
["SvgoCommonIconTradeWithUs", LazySvgoCommonIconTradeWithUs],
["SvgoCommonIconUnsubscribe", LazySvgoCommonIconUnsubscribe],
["SvgoCommonIconWallet", LazySvgoCommonIconWallet],
["SvgoCommonIconX", LazySvgoCommonIconX],
["SvgoCommonKey", LazySvgoCommonKey],
["SvgoCommonLogo", LazySvgoCommonLogo],
["SvgoCommonMastercard", LazySvgoCommonMastercard],
["SvgoCommonNews", LazySvgoCommonNews],
["SvgoCommonSelector", LazySvgoCommonSelector],
["SvgoCommonSepa", LazySvgoCommonSepa],
["SvgoCommonSwift", LazySvgoCommonSwift],
["SvgoCommonToastWarn", LazySvgoCommonToastWarn],
["SvgoCommonVisa", LazySvgoCommonVisa],
["SvgoDevelopersCloseIndex", LazySvgoDevelopersCloseIndex],
["SvgoDevelopersGradientArrow", LazySvgoDevelopersGradientArrow],
["SvgoDevelopersLogoGoldExtended", LazySvgoDevelopersLogoGoldExtended],
["SvgoDevelopersOpenIndex", LazySvgoDevelopersOpenIndex],
["SvgoDevelopersStructureChart", LazySvgoDevelopersStructureChart],
["SvgoHomeCryptoinfrastrIcon", LazySvgoHomeCryptoinfrastrIcon],
["SvgoHomeFlagEuropean", LazySvgoHomeFlagEuropean],
["SvgoHomeFlagSouthAfrica", LazySvgoHomeFlagSouthAfrica],
["SvgoHomeFlagSouthKorea", LazySvgoHomeFlagSouthKorea],
["SvgoHomeLegendPayLogo", LazySvgoHomeLegendPayLogo],
["SvgoHomeMoreArrow", LazySvgoHomeMoreArrow],
["SvgoHomeProIcon", LazySvgoHomeProIcon],
["SvgoHomeSafeIcon", LazySvgoHomeSafeIcon],
["SvgoHomeSettlementIcon", LazySvgoHomeSettlementIcon],
["SvgoHomeSupportIcon", LazySvgoHomeSupportIcon],
["SvgoHomeTradingIcon", LazySvgoHomeTradingIcon],
["SvgoHomeWorldliquidityIcon", LazySvgoHomeWorldliquidityIcon],
["SvgoHomeZaIcon1", LazySvgoHomeZaIcon1],
["SvgoHomeZaIcon2", LazySvgoHomeZaIcon2],
["SvgoHomeZaIcon3", LazySvgoHomeZaIcon3],
["SvgoHomeZaIcon4", LazySvgoHomeZaIcon4],
["SvgoHomeZaIcon5", LazySvgoHomeZaIcon5],
["SvgoMenuFooterLogoWhite", LazySvgoMenuFooterLogoWhite],
["SvgoMenuHeaderLogo", LazySvgoMenuHeaderLogo],
["SvgoMenuLinkedIn", LazySvgoMenuLinkedIn],
["SvgoMenuLinkedinBlue", LazySvgoMenuLinkedinBlue],
["SvgoMenuMMenuBlack", LazySvgoMenuMMenuBlack],
["SvgoMenuMMenuClose", LazySvgoMenuMMenuClose],
["SvgoMenuMMenuWhite", LazySvgoMenuMMenuWhite],
["SvgoMenuMMenu", LazySvgoMenuMMenu],
["SvgoMenuTreasureBox", LazySvgoMenuTreasureBox],
["SvgoMenuTriangle", LazySvgoMenuTriangle],
["SvgoMenuTwitterBlue", LazySvgoMenuTwitterBlue],
["SvgoMenuTwitter", LazySvgoMenuTwitter],
["SvgoMenuX", LazySvgoMenuX],
["SvgoShadowbgChartlineGold", LazySvgoShadowbgChartlineGold],
["SvgoShadowbgEdge", LazySvgoShadowbgEdge],
["SvgoShadowbgEdge2", LazySvgoShadowbgEdge2],
["SvgoShadowbgShapeInterrupt", LazySvgoShadowbgShapeInterrupt],
["SvgoTradingOtcLiquidityIcon", LazySvgoTradingOtcLiquidityIcon],
["SvgoTradingOtcSettlementIcon", LazySvgoTradingOtcSettlementIcon],
["SvgoTradingOtcWorldclassIcon", LazySvgoTradingOtcWorldclassIcon],
["ProseA", LazyProseA],
["ProseBlockquote", LazyProseBlockquote],
["ProseCode", LazyProseCode],
["ProseEm", LazyProseEm],
["ProseH1", LazyProseH1],
["ProseH2", LazyProseH2],
["ProseH3", LazyProseH3],
["ProseH4", LazyProseH4],
["ProseH5", LazyProseH5],
["ProseH6", LazyProseH6],
["ProseHr", LazyProseHr],
["ProseImg", LazyProseImg],
["ProseLi", LazyProseLi],
["ProseOl", LazyProseOl],
["ProseP", LazyProseP],
["ProsePre", LazyProsePre],
["ProseScript", LazyProseScript],
["ProseStrong", LazyProseStrong],
["ProseTable", LazyProseTable],
["ProseTbody", LazyProseTbody],
["ProseTd", LazyProseTd],
["ProseTh", LazyProseTh],
["ProseThead", LazyProseThead],
["ProseTr", LazyProseTr],
["ProseUl", LazyProseUl],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
